<template>
  <v-container ma-0 pa-0 fluid fill-height>
   
    <v-layout fill-height>
      <v-flex xs12 pa-0 fill-height>
        <div v-if="screenMode" class="screenColor">
          <div
            v-for="p in pixels"
            class="pixel"
            :style="'top:'+pixelY(p)+'px;left:'+pixelX(p)+'px;background-color:'+p.color+';'"
          ></div>
         
          <div class="pixelEffect">
           
            <div
              v-for="p in effect"
              class="pixel"
              :style="'top:'+p.y+'px;left:'+p.x+'px;background-color:'+p.c+';'"
            ></div>
          </div>
        </div>
        <div v-if="!screenMode" class="screenColor" style="position:relative;" @mouseup="moveY=0">
          <div
            class="cPixel"
            :style="{backgroundColor: pixelColour}"
            @mousedown="cDown=true"
            @touchstart="cDown=true"
            @mouseup="centerUp"
            @touchend="centerUp"
            @touchcancel="centerUp"
          ></div>
          <div
            class="arrow-up"
            @mousedown="moveY=-1"
            @touchstart="moveY=-1"
            @mouseup="mouseUp"
            @touchend="mouseUp"
            @touchcancel="mouseUp"
          ></div>
          <div
            class="arrow-down"
            @mousedown="moveY=1"
            @touchstart="moveY=1"
            @mouseup="mouseUp"
            @touchend="mouseUp"
            @touchcancel="mouseUp"
          ></div>
          <div
            class="arrow-right"
            @mousedown="moveX=1"
            @touchstart="moveX=1"
            @mouseup="mouseUp"
            @touchend="mouseUp"
            @touchcancel="mouseUp"
          ></div>
          <div
            class="arrow-left"
            @mousedown="moveX=-1"
            @touchstart="moveX=-1"
            @mouseup="mouseUp"
            @touchend="mouseUp"
            @touchcancel="mouseUp"
          ></div>
          <div v-if="false" class="pixelName">PIXEL {{cDown}}</div>
        </div> 
        <div v-if="screenMode" class="screenText">www.theloophobart.com.au/pixel</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  
  data() {
    return {
      hasTouch: false,
      canvas: null,
      ctx: null,
      xPos: null,
      yPos: null,
      screenCol: null,
      mouseIsDown: false,
      moveY: 0,
      moveX: 0,
      pixelSpeed: 5,
      cDown: false,
      cDownFor: 0,
      colourIndex: 0,
      effectIndex:0,
      colours: [
        "rgb(255,   255,   255)",
        "rgb(255,   0,   0)",
        "rgb(255,   0, 255)",
        "rgb(0,     0, 255)",
        "rgb(0,   255, 255)",
        "rgb(0,   255,   0)",
        "rgb(255, 255,   0)",
        "rgb(255,   127,   0)"
      ],
      effect: {},
     
    };
  },
  mounted() {
    window.requestAnimationFrame(this.step);
    //this.$store.dispatch('loadStatus');
    if (!this.screenMode) {
      this.$store.dispatch("loadPixels");

      this.$store.dispatch("addPixel");
    } else {
      //this.$store.dispatch("loadPixels");
      this.$store.dispatch("resetPixels");
      this.$store.dispatch("loadPixels");
       this.addVEffect(300,300,"#0f0")
       this.addHEffect(300,300,"#0f0")
      
    }

    
    

  },
  computed: {
    pixelColour() {
      if (this.pixel) {
        return this.pixel.color;
      }
      return "rgb(50, 50, 50)";
    },
    pixelIndex() {
      return this.$store.getters.getPixelIndex;
    },
    screenMode() {
      return this.$route.path.indexOf("screen") > -1;
    },
    pixel() {
      console.log(this.pixels);
      for (var p in this.pixels) {
        console.log("PX", p);
        if (p == "pixel" + this.pixelIndex) {
          this.pixels[p].id = p;
          return this.pixels[p];
        }
      }
      return null;
    },
    pixels() {
      return this.$store.getters.getPixels;
    },
    colour() {
      return this.$store.getters.getColour;
    },

    loading() {
      return this.$store.getters.loading;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  },

  methods: {
    addVEffect(x,y,c){
      this.$set(this.effect,"v"+this.effectIndex,{ vis:true,x: x, y: y,vx:0,vy:10, c: c })
      this.effectIndex++
      this.$set(this.effect,"v"+this.effectIndex,{ vis:true,x: x, y: y,vx:0,vy:-10, c: c })
      this.effectIndex++
    },
    addHEffect(x,y,c){
      this.$set(this.effect,"v"+this.effectIndex,{ vis:true,x: x, y: y,vx:10,vxy:0, c: c })
      this.effectIndex++
      this.$set(this.effect,"v"+this.effectIndex,{ vis:true,x: x, y: y,vx:-10,vxy:0, c: c })
      this.effectIndex++
    },
    pixelX(p) {
      return ((p.xpos % window.innerWidth) + window.innerWidth) % window.innerWidth ;
    },
    pixelY(p) {
      return ((p.ypos % window.innerHeight) + window.innerHeight) % window.innerHeight;
    },

    step() {
      let hasEffect
      for (var p in this.effect){
        if(this.effect[p].vis){
        this.$set( this.effect[p],"y",this.effect[p].y+this.effect[p].vy)
        this.$set( this.effect[p],"x",this.effect[p].x+this.effect[p].vx)
        if(this.effect[p].x>window.innerWidth){
          this.$set( this.effect[p],"vis",false)
           //delete this.effect[p]
        }else  if(this.effect[p].x<0){
          this.$set( this.effect[p],"vis",false)
           //delete this.effect[p]
        }if(this.effect[p].y>window.innerHeight){
          this.$set( this.effect[p],"vis",false)
          // delete this.effect[p]
        }else  if(this.effect[p].y<0){
          this.$set( this.effect[p],"vis",false)
          // delete this.effect[p]
        }
      }
        if(this.screenMode){
          
          for(var p in this.pixels){
            
            for(var t in this.pixels){
              hasEffect=false
              if(p!=t){
                
                if( this.pixels[p].xpos>0 && this.pixelX(this.pixels[p])== this.pixelX(this.pixels[t])){
                  if(!this.pixels[p].hasEffect){
                    hasEffect=true
                    this.addVEffect(this.pixelX(this.pixels[p]),this.pixelY(this.pixels[p]),this.pixels[p].color)
                  }
                   if(!this.pixels[t].hasEffect){
                     hasEffect=true
                     this.addVEffect(this.pixelX(this.pixels[t]),this.pixelY(this.pixels[t]),this.pixels[t].color)
                   }
                }
                
                if( this.pixels[p].ypos>0 && this.pixelY(this.pixels[p]) == this.pixelY(this.pixels[t])){
                  
                  if(!this.pixels[p].hasEffect){
                    hasEffect=true
                    this.addHEffect(this.pixelX(this.pixels[p]),this.pixelY(this.pixels[p]),this.pixels[p].color)
                  }
                   if(!this.pixels[t].hasEffect){
                     hasEffect=true
                     this.addHEffect(this.pixelX(this.pixels[t]),this.pixelY(this.pixels[t]),this.pixels[t].color)
                   }
                }
                if (hasEffect){
                  this.pixels[p].hasEffect=true
                  this.pixels[t].hasEffect=true
                }
              }
            }

          }

        }
      }
      if (this.pixel) {
        if (this.moveY) {
          this.pixel.ypos += this.moveY * this.pixelSpeed;
          this.$store.dispatch("setPixel", this.pixel);
          this.pixels.hasEffect=false;
        }
        if (this.moveX) {
          this.pixel.xpos += this.moveX * this.pixelSpeed;
          this.$store.dispatch("setPixel", this.pixel);
          this.pixels.hasEffect=false;
        }
        if (this.cDown) {
          this.cDownFor++;
          if (this.cDownFor > 200) {
            this.pixel.color = this.colours[
              Math.floor((this.cDownFor - 200) / 50) % this.colours.length
            ];
          } else {
            this.pixel.color = this.colours[0];
          }
        }
      }
      window.requestAnimationFrame(this.step);
    },
    moveUp() {
      console.log(this.pixels.pixel1);
      //this.$store.dispatch("setColour", "rgb(255,255,0)");
      //this.pixels.pixel1.ypos -= 10;
      this.$store.dispatch("setPixel", this.pixels.pixel1);
    },

    mouseDown(event) {
      this.mouseIsDown = true;
      this.mouseMove(event);
    },
    centerUp(event) {
      this.cDown = false;
      this.cDownFor = 0;
      this.$store.dispatch("setPixel", this.pixel);
    },
    mouseUp(event) {
      this.mouseIsDown = false;
      this.moveY = 0;
      this.moveX = 0;
    },
    
    
    
    
  },
  beforeDestroy() {}
};
</script>
<style>
main {
  height: 100%;
  overflow: hidden;
}
</style>
<style scoped>
.pixelName {
  position: absolute;
  font-size: 30px;
  top: 0px;
  height: 40px;

  left: 0px;
  right: 0px;
  width: 200px;
  text-align: center;
  margin: auto;
}
.screenText {
  position: absolute;
  bottom: 50px;
  text-align: center;
  width: 100%;
  font-size: 30px;
  color: #fff;
  opacity: 0.1;
  text-shadow: 0px 0px 10px #000;
}
.screenPreview {
  color: #fff;
  text-shadow: 0px 0px 10px #000;
  background-color: #000;
}
.screenColor {
  height: 100%;
  color: #fff;
  background-color: #000;
}
.pixel {
  width: 2px;
  height: 2px;
  background-color: #fff;
  position: absolute;
}
.cPixel {
  position: absolute;
  width: 50px;
  height: 50px;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  background-color: #fff;
}
.arrow-up {
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-bottom: 50px solid rgba(255, 255, 255, 0.1);
  top: calc(50% - 100px);
  left: calc(50% - 50px);
}

.arrow-down {
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-left: 50px solid transparent;
  border-right: 50px solid transparent;
  border-top: 50px solid rgba(255, 255, 255, 0.1);
  top: calc(50% + 50px);
  left: calc(50% - 50px);
}

.arrow-right {
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 50px solid rgba(255, 255, 255, 0.1);
  top: calc(50% - 50px);
  left: calc(50% + 50px);
}

.arrow-left {
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-right: 50px solid rgba(255, 255, 255, 0.1);
  top: calc(50% - 50px);
  left: calc(50% - 100px);
}
</style>



// WEBPACK FOOTER //
// src/components/Play/Pixel.vue